import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');

        if (token && userData) {
            try {
                setUser(JSON.parse(userData));
            } catch (err) {
                // Corrupt storage would otherwise throw here and leave the whole
                // app on a blank screen with no way back to the login form.
                console.error('Stored user data is unreadable, signing out.', err);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
            }
        }
        setLoading(false);
    }, []);

    const login = async (phoneNumber, password) => {
        const response = await authService.login(phoneNumber, password);
        localStorage.setItem('token', response.token);
        localStorage.setItem('user', JSON.stringify(response.user));
        if (response.user.language) {
            localStorage.setItem('language', response.user.language);
        }
        // Store doctor profile data if user is a doctor
        if (response.user.role === 'doctor') {
            localStorage.setItem('doctorProfile', JSON.stringify(response.user));
        }
        setUser(response.user);
        return response;
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    const updateUser = (updatedUser) => {
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
        // Also store doctor profile data if user is a doctor
        if (updatedUser.role === 'doctor') {
            localStorage.setItem('doctorProfile', JSON.stringify(updatedUser));
        }
    };

    const value = {
        user,
        setUser: updateUser,
        login,
        logout,
        loading,
        isAuthenticated: !!user
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};
